// extracted by mini-css-extract-plugin
export default {"content-wrap":"content-wrap--kJhQn","contentWrap":"content-wrap--kJhQn","blink":"blink--DPlEg"};